///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { createSlice } from "@reduxjs/toolkit";
import { getSpotLegById } from "../api/api";
import types from "../helpers/types";

export const initialState = {
  requestStatus: types.requestStatuses.initial,
  spotLeg: null,
};

const spotLegSlice = createSlice({
  name: "spotLegSlice",
  initialState,
  reducers: {
    requestSpotLeg: (state) => {
      state.requestStatus = types.requestStatuses.inProgress;
    },
    receiveSpotLegSuccess: (state, { payload }) => {
      state.spotLeg = payload;
      state.requestStatus = types.requestStatuses.success;
    },
    receiveSpotLegFailure: (state) => {
      state.requestStatus = types.requestStatuses.failure;
    },
    clearSpotLeg: (state) => {
      state.spotLeg = null;
    },
  },
});

export const {
  requestSpotLeg,
  receiveSpotLegSuccess,
  receiveSpotLegFailure,
  clearSpotLeg,
} = spotLegSlice.actions;

export const fetchSpotLegById =
  (spotLegId, triggerNotification) => async (dispatch) => {
    let spotLeg;
    dispatch(requestSpotLeg());
    try {
      spotLeg = await getSpotLegById(spotLegId);
    } catch (e) {
      if (triggerNotification && e.response?.status === 400) {
        dispatch(clearSpotLeg());
        triggerNotification(types.notifications.legUnavailable);
      }
      dispatch(receiveSpotLegFailure());
      return;
    }
    dispatch(receiveSpotLegSuccess(spotLeg));
  };

export const spotLegReducer = spotLegSlice.reducer;
